import { themeContract } from '@ui/theme/typography/contract.css'

export default themeContract.weights
